// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-user-view-item img.avatar{margin:-3px 7px 0 0;vertical-align:middle}`, "",{"version":3,"sources":["webpack://./client/Entities/User/Components/user.scss"],"names":[],"mappings":"AACI,iCACI,mBAAA,CACA,qBAAA","sourcesContent":[".react-user-view-item {\n    img.avatar {\n        margin: -3px 7px 0 0;\n        vertical-align: middle;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
